import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import logo from "../../assets/images/logo.png";
import { AnimatePresence, motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import ApiService from "../../services/ApiService.js";
import { toast } from "react-toastify";
import OtpInput from 'react-otp-input';
import AuthTalentGuard from "../../components/AuthTalentGuard.jsx";
import { useTranslation } from "react-i18next";

const VerifyOTP = () => {
  const [otp, setOTP] = useState('');
   const { t, i18n } = useTranslation();
     const isRTL = i18n.language === 'ar';
  const [isResending, setIsResending] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);

  const [isLoader, setIsLoader] = useState(false);
  const inputsRef = useRef([]);
  const navigate = useNavigate();

  const talent_id = localStorage.getItem("talent_id");
  console.log(talent_id);

  const phone = localStorage.getItem("phone");
  console.log(phone);

  const deviceToken = localStorage.getItem("deviceToken");
  const clearCompanyData = () => {
    const companyData = localStorage.getItem("company");
    if (companyData) {
      localStorage.removeItem("company");
      localStorage.removeItem("token");
      // Optional: Show message to user
      console.log("Previous company session cleared");
    }
  };
  useEffect(() => {
    if (!resendTimer) return;
    const id = setInterval(() => setResendTimer((t) => t - 1), 1000);
    return () => clearInterval(id);
  }, [resendTimer]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!talent_id) {
      toast.error("Missing registration data. Please register again.");
      navigate("/");
    }
    if (!talent_id) {
      toast.error("No user ID found – please sign‑up again.");
    }
  }, [talent_id, navigate]);



  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);

    if (otp.length !== 6) {
      toast.error("Please enter the 6‑digit OTP");
      setIsLoader(false);
      return;
    }

    try {
            clearCompanyData();

      const res = await ApiService.request({
        method: "POST",
        url: "verifyOTP",
        data: {
          otp: otp,
          talent_id,
        },
      });

      const data = res.data;
      if (data.status) {
        toast.success(data.message);
        const talent = data.data.talent;
        talent.auth_token = data.data.auth_token;
        localStorage.setItem("user", JSON.stringify(talent));
        navigate("/talent/dashboard");
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      setIsLoader(false);
      console.error("OTP verification failed:", err);
      toast.error("OTP verification failed. Please try again.");
    } finally {
      setIsLoader(false);
    }
  };

  const handleResendOTP = async () => {
    // block clicks while counting down
    if (isResending || resendTimer > 0) return;

    setIsResending(true);
    try {
      const res = await ApiService.request({
        method: "POST",
        url: "resendOTP",
        data: {
          talent_id,
          phone,
        },
      });

      const data = res.data;
      if (data.status) {
        toast.success(data.message || "A new code has been sent.");
        setResendTimer(60);
      } else {
        toast.error(data.message || "Unable to resend OTP.");
      }
    } catch (err) {
      console.error("Resend OTP failed:", err);
      toast.error("Failed to resend OTP. Please try again.");
    } finally {
      setIsResending(false);
    }
  };

  return (
    // <AuthTalentGuard>
<AnimatePresence mode="wait">
  <motion.div
    key="main"
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -50 }}
    transition={{ duration: 0.5 }}
    className="inter-font main-bg min-vh-100 d-flex flex-column justify-content-center align-items-center"
    style={{ direction: isRTL ? "rtl" : "ltr" }}
  >
    <Container className="inter-font position-absolute top-0 mt-3">
      <Row className="inter-font align-items-start">
        <Link to={"/"} xs={12} className="inter-font text-center text-md-start mb-2 mb-md-0 cursor-pointer">
          <img src={logo} alt="Logo" style={{ height: "50px" }} />
        </Link>
      </Row>
    </Container>

    <div
      className="inter-font container upload-doc-coontainer bg-white p-4 d-flex flex-column justify-content-center align-items-center rounded-4"
      style={{ width: "90%", maxWidth: "700px" }}
    >
      <h2
        className="inter-font fw-bold mt-4 text-center"
        style={{ fontSize: "25px", textAlign: isRTL ? "right" : "left" }}
      >
        {t("t_reg_s4_verify_title")}
      </h2>

      <p
        className="inter-font text-center"
        style={{ color: "rgba(0, 0, 0, 0.3)", textAlign: isRTL ? "right" : "left" }}
      >
        {t("t_reg_s4_verify_dec")}
      </p>

      <Form onSubmit={handleSubmit} className="inter-font w-100">
        <div className="inter-font d-flex flex-column align-items-center w-100">
          <div className="inter-font d-flex gap-2 gap-md-4 mb-3 flex-wrap justify-content-center">
            <OtpInput
              value={otp}
              onChange={(value) => setOTP(value)}
              numInputs={6}
              separator={<span>-</span>}
              renderInput={(props) => <input {...props} className="otp-input" />}
            />
          </div>

          <p className="inter-font mb-0 text-center" style={{ textAlign: isRTL ? "right" : "left" }}>
            {t("c_reg_s4_text")}
            <span
              className="inter-font"
              style={{
                color: resendTimer ? "gray" : "#5e4b00",
                fontWeight: 500,
                cursor: resendTimer ? "default" : "pointer",
                marginRight: isRTL ? "8px" : "0",
                marginLeft: isRTL ? "0" : "8px"
              }}
              onClick={resendTimer ? undefined : handleResendOTP}
            >
              {resendTimer
                ? `${t("resend_in")} ${resendTimer}s`
                : isResending
                ? t("sending")
                : t("c_reg_s4_resend")}
            </span>
          </p>
        </div>

        <div className="inter-font d-flex justify-content-center mt-4">
          <Button
            type="submit"
            className="inter-font btn btn-base border-0"
            style={{ 
              width: "100%", 
              maxWidth: "200px", 
              height: "55px",
              backgroundColor: "#E26A52",
              color: "#fff"
            }}
            disabled={isLoader}
          >
            {isLoader ? t("processing") : t("c_continue")}
          </Button>
        </div>
      </Form>
    </div>
  </motion.div>
</AnimatePresence>
    // </AuthTalentGuard>
  );
};

export default VerifyOTP;
